var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "megaphone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68311 8.13477L11.685 19.3382C11.717 19.4574 11.719 19.5827 11.6909 19.703C11.6628 19.8232 11.6055 19.9346 11.524 20.0274L10.7064 20.9577C10.627 21.048 10.5272 21.1179 10.4152 21.1615C10.3032 21.2051 10.1823 21.2211 10.0628 21.2083C9.94334 21.1954 9.82868 21.1541 9.72851 21.0876C9.62835 21.0212 9.54562 20.9317 9.48728 20.8266L7.00203 16.3498",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00171 16.3489C6.04103 16.6063 5.01745 16.4715 4.15614 15.9742C3.29482 15.4769 2.66632 14.6579 2.40891 13.6972C2.1515 12.7365 2.28626 11.7129 2.78354 10.8516C3.28082 9.99031 4.09989 9.36182 5.06056 9.10441L8.68279 8.13384C8.68279 8.13384 13.6137 6.81261 17.2924 1.56147C17.3741 1.44437 17.4876 1.35305 17.6194 1.29823C17.7513 1.24342 17.8961 1.2274 18.0367 1.25205C18.1774 1.27671 18.3081 1.34101 18.4134 1.43741C18.5188 1.5338 18.5944 1.65827 18.6315 1.79619L22.4086 15.8925C22.4455 16.0305 22.4422 16.1761 22.3991 16.3122C22.3561 16.4484 22.2751 16.5694 22.1656 16.6611C22.0561 16.7528 21.9227 16.8113 21.7811 16.8298C21.6395 16.8482 21.4956 16.8259 21.3662 16.7653C15.5548 14.057 10.6239 15.3783 10.6239 15.3783L7.00171 16.3489Z",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.e74927fb.svg";
export { ForwardRef as ReactComponent };